<div
  class="flex gap-2 justify-between p-4"
  [class.border-last-item]="operation.id === Xota2OperationProcessId.REPORT_GENERATION"
  *ngIf="operation.status !== Xota2UpdateProgress.UPDATES_NOT_AVAILABLE"
>
  <div class="flex-col gap-2">
    <ng-container [ngSwitch]="operation.id">
      <ng-container *ngSwitchCase="Xota2OperationProcessId.TCU_STATUS">
        <p>{{ 'FIRMWARE_UPDATE_MODAL.XOTA2_FIRMWARE_UPDATING.PROCESS.TCU_STATUS' | translate }}</p>
      </ng-container>

      <ng-container *ngSwitchCase="Xota2OperationProcessId.VERIFYING_UPDATE_METHOD">
        <p>
          {{
            'FIRMWARE_UPDATE_MODAL.XOTA2_FIRMWARE_UPDATING.PROCESS.VERIFYING_UPDATE_METHOD'
              | translate
          }}
        </p>
      </ng-container>

      <ng-container *ngSwitchCase="Xota2OperationProcessId.ZIP_SERVICES">
        <p>
          {{ 'FIRMWARE_UPDATE_MODAL.XOTA2_FIRMWARE_UPDATING.PROCESS.ZIP_SERVICES' | translate }}
        </p>
      </ng-container>

      <ng-container *ngSwitchCase="Xota2OperationProcessId.FILE_TRANSFER">
        <p>
          {{ 'FIRMWARE_UPDATE_MODAL.XOTA2_FIRMWARE_UPDATING.PROCESS.FILE_TRANSFER' | translate }}
        </p>
      </ng-container>

      <ng-container *ngSwitchCase="Xota2OperationProcessId.UPDATE">
        <p>{{ 'FIRMWARE_UPDATE_MODAL.XOTA2_FIRMWARE_UPDATING.PROCESS.UPDATE' | translate }}</p>
      </ng-container>

      <ng-container *ngSwitchCase="Xota2OperationProcessId.REPORT_GENERATION">
        <p>
          {{
            'FIRMWARE_UPDATE_MODAL.XOTA2_FIRMWARE_UPDATING.PROCESS.REPORT_GENERATION' | translate
          }}
        </p>
      </ng-container>
    </ng-container>
    <p
      class="subtitle"
      *ngIf="
        operation.id === Xota2OperationProcessId.REPORT_GENERATION &&
        operation.status === Xota2UpdateProgress.CREATED
      "
    >
      {{
        'FIRMWARE_UPDATE_MODAL.XOTA2_FIRMWARE_UPDATING.PROCESS.REPORT_GENERATION_SUBTITLE'
          | translate
      }}
    </p>
  </div>

  <div [ngSwitch]="true">
    <!-- Success -->
    <ng-container
      *ngSwitchCase="
        [
          Xota2UpdateProgress.UPDATED,
          Xota2UpdateProgress.COMPLETED,
          Xota2UpdateProgress.CREATED,
          Xota2UpdateProgress.SENT,
          Xota2UpdateProgress.READ,
          Xota2UpdateProgress.XOTA_ONE,
          Xota2UpdateProgress.XOTA_TWO
        ].includes(operation.status)
      "
    >
      <mat-icon class="check-icon">check_circle</mat-icon>
    </ng-container>

    <!-- Waiting -->
    <!-- Success -->
    <ng-container
      *ngSwitchCase="
        [Xota2UpdateProgress.UPDATING, Xota2UpdateProgress.SENDING].includes(operation.status)
      "
    >
      <mat-spinner></mat-spinner>
    </ng-container>

    <!-- Error -->
    <ng-container *ngSwitchCase="[Xota2UpdateProgress.FAILED].includes(operation.status)">
      <mat-icon class="warning-icon">error</mat-icon>
    </ng-container>

    <!-- Not Executed -->
    <ng-container *ngSwitchCase="[Xota2UpdateProgress.NOT_EXECUTED].includes(operation.status)">
      <p class="capitalize">
        {{ 'FIRMWARE_UPDATE_MODAL.XOTA2_FIRMWARE_UPDATING.STATUS.NOT_EXECUTED' | translate }}
      </p>
    </ng-container>

    <!-- Pending -->
    <ng-container *ngSwitchDefault>
      <p class="capitalize">
        {{ 'FIRMWARE_UPDATE_MODAL.XOTA2_FIRMWARE_UPDATING.STATUS.PENDING' | translate }}
      </p>
    </ng-container>
  </div>
</div>
<hr />
